export default __webpack_public_path__ + "static/Miami-ccc7f803dc4cdb1c6e30dc0225d40816.webp";